import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { SettingsResponseData } from "../types/settings"

const getData = async () => {
  const { data } = await api.get(`/settings`)
  return data
}

export const useSettings = ()
  : QueryObserverBaseResult<SettingsResponseData> => {
  const { data, ...props } = useQuery<SettingsResponseData>(
    queryKeys.SETTINGS(),
    () => getData(),
  )
  return { data, ...props }
}
